import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useOutletContext } from "react-router-dom";
import { useParams } from "react-router-dom";
import Spinner from "../../components/ui/Spinner";
import { getPositionByStep, Step } from "../../helpers/stepHelper";

export default function Offer() {
  const { procurement, handleUpdateProcurement } = useOutletContext();
  const { uuidEnterprise } = useParams();
  const [bidder, setBidder] = useState();

  useEffect(() => {
    const result = procurement.enterprises.find(enterprise => enterprise.uuid === uuidEnterprise);
    setBidder(result);
  }, [procurement.enterprises, uuidEnterprise]);

  if (!bidder) {
    return <Spinner />;
  }

  return (
    <>
      <div className="text-lg uppercase font-medium text-center border-b border-gray-200 mb-10">
        <ul className="flex -mb-px overflow-x-auto no-scrollbar">
          <li className="me-2">
            <NavLink
              to="legal"
              className={({ isActive }) => "inline-block p-4 border-b-2 hover:text-gray-600 hover:border-gray-300 " + (isActive ? "text-blue-600 border-blue-500" : "border-transparent")}
            >
              Données légales
            </NavLink>
          </li>
          <li className="me-2">
            <NavLink
              to="contacts"
              className={({ isActive }) => "inline-block p-4 border-b-2 hover:text-gray-600 hover:border-gray-300 " + (isActive ? "text-blue-600 border-blue-500" : "border-transparent")}
            >
              Contacts
            </NavLink>
          </li>
          <li className="me-2">
            <NavLink
              to="reviews"
              className={({ isActive }) => "inline-block p-4 border-b-2 hover:text-gray-600 hover:border-gray-300 " + (isActive ? "text-blue-600 border-blue-500" : "border-transparent")}
            >
              Notes
            </NavLink>
          </li>
          {
            getPositionByStep[procurement.step.name] >= getPositionByStep[Step.WRITING_ATTRIBUTION]
            && (
              <li className="me-2">
                <NavLink
                  to="offer"
                  className={({ isActive }) => "inline-flex items-center gap-2 p-4 border-b-2 hover:text-gray-600 hover:border-gray-300 " + (isActive ? "text-blue-600 border-blue-500" : "border-transparent")}
                >
                  <span>Offre</span>
                </NavLink>
              </li>
            )
          }
        </ul>
      </div>

      <Outlet context={{ bidder, procurement, handleUpdateProcurement }} />
    </>
  );
}
